// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"PersistentInfoDialog_checkboxContainer__4B7qB","checkbox":"PersistentInfoDialog_checkbox__iDIXj","checkboxIcon":"PersistentInfoDialog_checkboxIcon__BmGiu"};